<template>
    <div>
        <Card>
            <p slot="title">
                Buat Kontra
            </p>
    <Radio-group
        v-model="showBy"
        type="button"
        size="small"
        slot="extra">
        <Radio label="All"></Radio>
        <Radio label="Per Marking"></Radio>
    </Radio-group>


            <Row type="flex" justify="space-between" class="code-row-bg">
                <Col span="4">
                    <Date-picker v-model="invoiceDate"
                        type="date"
                        placeholder="Tgl. Invoice"
                        format="dd/MM/yyyy">
                    </Date-picker>
                </Col>
                 <Col span="5">
                    <DatePicker
                        v-model="dateFromTo"
                        type="daterange"
                        split-panels placeholder="Tgl. Bongkar"
                        ></DatePicker>
                </Col>

                <Col span="4">
                    <Select v-model="selectDepartement"
                        clearable
                        placeholder="Dept. Item"
                        @on-change="onSelectDepartementChange"
                        >
                        <Option v-for="dept, idx in departements" :value="dept.id" :key="idx">
                            {{ dept.deptName }}
                        </Option>
                    </Select>
                </Col>
                <Col span="2">
                    <Select
                        v-if="searchSelectSubbranch == 'JKT'"
                        v-model="searchSelectSubbranch"
                        disabled
                        placeholder="Branchcode"
                        @on-change="setMarkingCode"
                        >
                        <Option v-for="subbranch, idx in subbranchs" :value="subbranch.subbranchcode" :key="idx">
                            {{ subbranch.subbranchname }}
                        </Option>
                    </Select>
                    <Select
                        v-else
                        v-model="searchSelectSubbranch"
                        disabled
                        placeholder="Branchcode"
                        @on-change="setMarkingCode"
                        >
                        <Option v-for="subbranch, idx in subbranchs" :value="subbranch.subbranchcode" :key="idx">
                            {{ subbranch.subbranchname }}
                        </Option>
                    </Select>



                </Col>

                <Col span="4">

                    <Select
                        v-show="showBy == 'Per Marking'"
                        placeholder="Ketik Marking"
                        v-model="markingIdSelected"
                        filterable
                        clearable
                        remote
                        :remote-method="getMarkingByCode"
                        :loading="loadingGetMarking"
                        >
                        <Option v-for="(option, index) in optionMarkings"
                            :value="option.value" :key="index">{{option.label}}</Option>
                    </Select>

                </Col>

                <Col span="4">
                    <Button type="primary"
                        v-show="showSearchButton()"
                        :loading="loadingGetReadyKontra"
                        icon="ios-search-strong"
                        @click="getReadyKontra">
                        <span v-if="!loadingGetReadyKontra">Cari</span>
                        <span v-else>Wait.</span>
                    </Button>
                </Col>
            </Row>

            <br>

            <div v-if="invoicesToShow.length > 0">
                <Table
                    :columns="tableColumns"
                    :data="invoicesToShow"
                    @on-selection-change="onSelectionChange"
                    no-data-text=""
                ></Table>

            </div>
        </Card>

        <div class="footer" v-show="!loadingGetReadyKontra && invoicesChecked.length > 0">
            <h3>{{ invoicesChecked.length }} invoice Selected
            <Button
              type="primary"
              :loading="loadingPost"
              @click="createKontra"
              icon="checkmark-round"
              size="small"  >
                <span v-if="!loadingPost">Submit</span>
                <span v-else>Wait.....</span>

              </Button>


            </h3>
        </div>

    </div>
</template>

<script>
import {HTTP} from '@/components/http-lib'

import _ from 'lodash'

import moment from 'moment'

import cKontraCreateRow from '@/components/kontra/cKontraCreateRow'

const numeral = require('numeral');

export default {
    data: () => ({
        showBy : 'All',
        invoices : [],
        loadingPost : false,
        loadingGetReadyKontra : false,
        markingIdSelected : '',
        loadingGetMarking: false,
        optionMarkings : [],
        invoiceDate : '',
        departementId : '',
        selectDepartement : '',
        markingCode : '',
        departements : [],
        invoicesToShow : [],
        invoicesChecked  : [],
        dateFromTo : [],
        searchSelectSubbranch : localStorage.getItem('user.subbranchcode'),
        subbranchs: '',
        tableColumns: [
            {
                type: 'selection',
                width: 60,
                align: 'center',
                fixed: 'left'
            },
            {
                title: 'Marking',
                key: 'markingcode',
                width: 100,
                sortable: true
            },
            {
                title: 'Partai',
                key: 'containercode',
                width: 100,
                sortable: true
            },
            {
                title: 'Tgl Load',
                width: 100,
                key: 'loaddate',
                sortable: true
            },
            {
                title: 'Dept',
                key: 'itemDeptName',
                width: 100,
                sortable: true
            },
            {
                title: 'Tgl Bongkar',
                width: 140,
                key: 'invoicedate',
                sortable: true
            },
            {
                title: 'Jt Tempo',
                key: 'invoicedatedue',
                width: 140,
                sortable: true
            },
            {
                title: 'CTNS',
                width: 70,
                key: 'totalctns'
            },
            {
                title: 'Vol-Gw',
                key: 'volGw'
            },
            {
                title: 'Total',
                align: 'right',
                fixed: 'right',
                key: 'invoicefee'
            }

        ],
        filterInput : ''

    }),
    components : {cKontraCreateRow},
    methods: {
        showSearchButton : function(){
            if(this.showBy == 'All'){
                return true;
            }

            else if(this.markingIdSelected != '' && this.showBy != 'All'){
                return true;
            }

            else {
                return false
            }
        },
        getReadyKontra: function(){
            this.loadingGetReadyKontra = true

            let subbranchcode = localStorage.getItem('user.subbranchcode');

            if(this.invoiceDate != ''){
                this.invoiceDate = moment(this.invoiceDate).format('YYYY/MM/DD')
            }

            if(this.selectDepartement == '') {
              this.$Notice.warning({
                    title: "Perhatian !",
                    desc: "Silahkan pilih Departemen terlebih dahulu",
                    duration: 5
                });

                this.loadingGetReadyKontra = false

                return false
            }

            let dateCreateFrom =  moment(this.dateFromTo[0], 'YYYY-MM-DD', true)
            let dateCreateTo =  moment(this.dateFromTo[1], 'YYYY-MM-DD', true)

            let dateCreateFromValid = dateCreateFrom.isValid() == false ?  '' : dateCreateFrom.format("YYYY-MM-DD");
            let dateCreateToValid = dateCreateTo.isValid() == false ?  '' : dateCreateTo.format("YYYY-MM-DD");

            HTTP
            .post('invoice/readyCreateKontra', {
                invoiceDate: this.invoiceDate ,
                departementId: this.selectDepartement,
                markingHeaderId: this.markingIdSelected,
                subbranchcode: this.searchSelectSubbranch || null,
                startArrivalDate: dateCreateFromValid,
                endArrivalDate: dateCreateToValid
            })
            .then(response => {
              this.invoicesToShow = [];
              this.invoicesChecked = [];

                var formattedInvoices = [];
                _.forEach(response.data, function(value) {
                    let invoice = {
                        invoiceid : value.invoiceid,
                        invoicedate : value.invoicedate,
                        invoicedatedue : value.invoicedatedue,
                        // markingcode : value.packaging_list.marking_minified.markingheadercode,
                        // containercode : value.packaging_list.container_loading.containercode,
                        // loaddate : value.packaging_list.container_loading.loaddate,
                        // itemDeptId : value.item_dept.id,
                        // itemDeptName : value.item_dept.deptName,
                        markingcode : value.markingheadercode,
                        containercode : value.containercode,
                        loaddate : value.loaddate,
                        itemDeptId : value.itemDeptId,
                        itemDeptName : value.deptName,
                        totalctns : value.totalctns,
                        volGw :
                                numeral(value.totalvolume).format('0.000') +
                                ' - ' +  numeral(value.totalgw).format('0'),
                        invoicefee : numeral(value.invoicefee).format('0,0'),
                    }

                    formattedInvoices.push(invoice);

                    // console.log(invoice.markingcode)

                });
                //console.log(formattedInvoices)
                this.invoices = formattedInvoices;
                this.invoicesToShow = formattedInvoices;

                if(this.showBy == 'All'){
                    this.invoicesChecked = this.invoicesToShow;
                }

                this.loadingGetReadyKontra = false
            })
            .catch(e => {
                //console.log(e);
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });

                this.loadingGetReadyKontra = false
            })
        },
        getDepartement: function(){
            HTTP
            .get('itemDept')
            .then(response => {
                this.departements = response.data
            })
            .catch(e => {
                //console.log(e);
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            })
        },
        getSubbranch: function(){
                HTTP
                .get('subbranch')
                .then(response => {
                    this.subbranchs = response.data
                })
                .catch(e => {
                    //console.log(e);
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
            },
        setMarkingCode: function(){
            this.markingIdSelected = ''
        },

        createKontra: function(){
            this.loadingPost = true;
            let invoiceGrouped = groupBy(this.invoicesChecked, 'markingcode', 'markingcode', 'invoices');

            HTTP
            .post('kontra/create', {
                invoiceBundles: invoiceGrouped
            })
            .then(response => {
                this.loadingPost = false;
                this.getReadyKontra();
            })
            .catch(e => {
                this.loadingPost = false;
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            })
        },

        onSelectionChange: function (selection) {
            this.invoicesChecked = selection
        },
        onSelectDepartementChange: function (deptId) {
        },
        getMarkingByCode: _.debounce(
            function (query) {
                if (query !== '') {
                    this.loadingGetMarking = true;

                    HTTP
                    .post('marking/getBySnapshot', {
                        markingHeaderId: query,
                        subbranchcode: this.searchSelectSubbranch || null
                    })
                    .then(response => {
                        this.loadingGetMarking = false;
                        let data = response.data;

                        const list = data.map(item => {
                            return {
                                value: item.markingheaderid,
                                label: item.markingheadercode
                            };
                        });

                        this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                        // console.log(this.optionMarkings[0]);
                    })
                    .catch(e => {
                        this.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    })
                } else {
                    this.optionMarkings = [];
                }
            }, 400
        ),
    },
    watch: {
        filterInput: function (textToSearch) {
            this.doFilter(textToSearch)
        },
        showBy: function (newValue) {

            this.invoicesToShow = [];
            this.invoicesChecked = [];

            if(newValue == 'All'){
                this.markingIdSelected = ''
            }
        }



    },
  created() {
    this.getDepartement();
    this.getSubbranch();
  }
}

function groupBy(dataToGroupOn, fieldNameToGroupOn, fieldNameForGroupName, fieldNameForChildren) {
    var result = _.chain(dataToGroupOn)
        .groupBy(fieldNameToGroupOn)
        .toPairs()
        .map(function (currentItem) {
            return _.zipObject([fieldNameForGroupName, fieldNameForChildren], currentItem);
        })
        .value();
    return result;
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// KontraCreate.vue?26a5aa30